import React from 'react'

export default function HeartIcon(props) {

    return (
        <>
            <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.9577 18.331H11.0398C9.13013 18.331 1.49976 12.2163 1.49976 5.76907C1.50098 4.62945 1.95414 3.53686 2.75997 2.73102C3.56579 1.92519 4.65841 1.47193 5.79802 1.4707C7.61894 1.4707 9.08701 2.52946 10.7089 5.00935L11.4992 6.218L12.2895 5.00935C13.9105 2.52891 15.3794 1.4707 17.2003 1.4707C18.3399 1.47193 19.4325 1.92519 20.2384 2.73102C21.0442 3.53686 21.4975 4.62945 21.4987 5.76907C21.4987 12.2188 13.8679 18.331 11.9577 18.331Z" stroke="white" strokeWidth="1.5" strokeMiterlimit="10" />
            </svg>
        </>
    )
}